import {SendSupportEmail} from "../Types";
import jsonApi from "./jsonApi";

export async function send(sendEmail: SendSupportEmail) {
  return await jsonApi.post<"ok">("/support_emails/send", sendEmail);
}
